export type SetFunction = <T>(currentValue: T) => T;
export const makeObservable = <T>(target?: T) => {
  type ValueSetter = (value: T) => void;

  let listeners: ValueSetter[] = []; // initial listeners can be passed an an argument as well
  let value: T = target;

  const get = (): T => value;

  const set = (newValue: T | SetFunction) => {
    if (typeof newValue === 'function') {
      value = newValue.call(newValue, value);
    } else {
      if (value === newValue) {
        return;
      }
      value = newValue;
    }
    listeners.forEach((listener) => listener(value));
  };

  const subscribe = (listenerFunction: ValueSetter) => {
    listeners.push(listenerFunction);
    return () => unsubscribe(listenerFunction); // will be used inside React.useEffect
  };

  const unsubscribe = (listenerFunction: ValueSetter) => {
    listeners = listeners.filter((listener) => listener !== listenerFunction);
  };

  return {
    get,
    set,
    subscribe,
  };
};
